/**
 * SzAgentPalette — gera cores estáveis por agente (via user.id) pra
 * identificar visualmente o autor de mensagens em conversas de GRUPO.
 *
 * Cada agente recebe um par { bg, fg } único e determinístico:
 *   bg = fundo do pill (claro, tipo wash de cor)
 *   fg = texto + avatar bg (cor escura saturada)
 *
 * Hash: id % len(PALETTE). 10 cores cobrem ~todos casos sem repetir
 * dentro de um time pequeno-médio.
 *
 * As 3 primeiras vêm direto do Figma Sadraque #363:
 *   - Julianna (purple), Jonas (green), Matheus (teal)
 * O resto preenche o círculo cromático.
 */

const PALETTE = [
  { bg: '#F3EEF2', fg: '#81336D', name: 'purple' },   // 0 — Julianna
  { bg: '#E9F2EA', fg: '#205F20', name: 'green' },    // 1 — Jonas
  { bg: '#E2F2F4', fg: '#20575F', name: 'teal' },     // 2 — Matheus
  { bg: '#E7EFFA', fg: '#1F4D80', name: 'blue' },     // 3
  { bg: '#FBEDE4', fg: '#8C4318', name: 'orange' },   // 4
  { bg: '#FCEAEE', fg: '#963256', name: 'pink' },     // 5
  { bg: '#EDEAFA', fg: '#3F2680', name: 'indigo' },   // 6
  { bg: '#FAF1D6', fg: '#6B5005', name: 'amber' },    // 7
  { bg: '#EEF5D7', fg: '#3D5B11', name: 'lime' },     // 8
  { bg: '#F4E9E0', fg: '#7A4928', name: 'brown' },    // 9
];

// Dark mode: bg = mesma fg com baixa opacidade; fg = clarear pra contrastar
// Estratégia: bg = fg + '24' (14% alpha), fg = mistura clara
const DARK_OVERRIDES = {
  0: { bg: 'rgba(129, 51, 109, 0.24)',  fg: '#E5B5D7' },
  1: { bg: 'rgba(32, 95, 32, 0.24)',    fg: '#A8D8A8' },
  2: { bg: 'rgba(32, 87, 95, 0.24)',    fg: '#A8D0D8' },
  3: { bg: 'rgba(31, 77, 128, 0.24)',   fg: '#A8C8E8' },
  4: { bg: 'rgba(140, 67, 24, 0.24)',   fg: '#E8B898' },
  5: { bg: 'rgba(150, 50, 86, 0.24)',   fg: '#E0A5BB' },
  6: { bg: 'rgba(63, 38, 128, 0.24)',   fg: '#BFB0E8' },
  7: { bg: 'rgba(107, 80, 5, 0.24)',    fg: '#D8C56A' },
  8: { bg: 'rgba(61, 91, 17, 0.24)',    fg: '#B5C97A' },
  9: { bg: 'rgba(122, 73, 40, 0.24)',   fg: '#D8B498' },
};

/**
 * Retorna { bg, fg, bgDark, fgDark } pra o id de agente.
 * @param {number|string|null|undefined} userId
 */
export function szAgentColors(userId) {
  const id = Number(userId) || 0;
  const idx = Math.abs(id) % PALETTE.length;
  const light = PALETTE[idx];
  const dark = DARK_OVERRIDES[idx] || PALETTE[idx];
  return {
    bg: light.bg,
    fg: light.fg,
    bgDark: dark.bg,
    fgDark: dark.fg,
    name: light.name,
    index: idx,
  };
}

/**
 * Determina iniciais ABREVIADAS pra avatar (1-2 letras).
 */
export function szInitials(name) {
  if (!name) return '?';
  const parts = String(name).trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
  return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
}
